import CurrentOverviewMap from "@/components/packages/CurrentOverviewMap";

export default [
  {
    path: "/current-overview-map",
    name: "CurrentOverviewMap",
    component: CurrentOverviewMap,
    meta: {
      requiresAuthentication: true
    }
  }
];
